/** One-line texts about a layer shared by the layer panel and the "older version" review. */
import type { MemberDTO } from '../../shared/dto/members';
import type { LayerView } from '../annotations/contract';
import type { T } from '../i18n';

/** "Aðeins þú" or "Deilt með: Allir, 1. tenór, Jón Jónsson". */
export function shareSummary(l: Pick<LayerView, 'shares'>, t: T, byId: ReadonlyMap<string, Pick<MemberDTO, 'fullName'>>): string {
  if (l.shares.length === 0) return t('annotate.layer_private');
  const parts = l.shares.map((s) =>
    s.type === 'all' ? t('audience.all') : s.type === 'section' ? t(`section.short.${s.section}`) : (byId.get(s.userId)?.fullName ?? t('annotate.someone')),
  );
  return t('annotate.layer_shared_with', { list: parts.join(', ') });
}
